import React from "react";
import styled from "styled-components";
import { breakpoints } from "../styles/variables";
import { getColor } from "./helpers/getColor";
import MailButton from "./Mitarbeiter/MailButton";
import Wrapper from "./Wrappers/Wrapper";

const KontaktElem = styled.article`
  padding: 20px;
  text-align: center;

  h4,
  p,
  b,
  a {
    color: ${(props) => props.contentcolor};
  }

  a {
    text-decoration: none;
  }

  h4 {
    font: 20px / 30px "FS Medium";
    margin-bottom: 10px;
  }

  p {
    display: block;
    font: 16px / 21px "FS Regular";
    margin-bottom: 12px;
    b,
    strong {
      font-family: "FS Medium";
    }
  }

  .line {
    width: 100%;
    margin: 4px auto 16px;
    height: 1px;
    background: ${(props) => props.contentcolor};
  }

  @media screen AND (min-width: ${breakpoints.tablet}px) {
    padding: 30px;

    h4,
    p,
    b {
      width: 80%;
      margin: 0 auto;
    }

    p {
      margin-bottom: 16px;
    }
  }

  @media screen AND (min-width: ${breakpoints.desktop}px) {
    padding: 40px;

    .line {
      margin-bottom: 37px;
    }

    p {
      font: 21px / 30px "FS Regular";
      margin-bottom: 37px;
    }

    h4 {
      font: 28px / 36px "FS Medium";
      margin-bottom: 16px;
    }
  }
`;

const Kontakt = ({ siteId, content }) => (
  <KontaktElem contentcolor={getColor(siteId)}>
    <Wrapper wider>
      <h4>Ihr Kontakt</h4>
      <div className="line" />
      <p>
        <b>{content.title}</b>
        <br />
        {content.adresseLine1}
        <br />
        {content.plzUndOrt}
        <br />
        <a href={"tel:" + content.telefon}>Telefon: {content.telefon}</a>
        <br />
        <br />
        <MailButton color={getColor(siteId)} email={content.email} />
      </p>
    </Wrapper>
  </KontaktElem>
);

export default Kontakt;
